import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { DispatchNoteBus } from "./DispatchNoteBus";
import { v_LocationDetailBus } from "./v_LocationDetailBus";

export class OrderNotesBus extends BaseBus
{
    constructor(busObj: OrderNotesBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
    }
    CID(): any {
        return this.orderNotesId;
    }
    setParentId(id: any) {
        this.orderId = id;
    }
    setId(id: any) {
        this.orderNotesId = id;
    }
    setFromBusobj(data: OrderNotesBus) {
        this.initialize(data);
        this.notes = data.notes;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(DateFunctions.getDateNow());
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.orderNotesPersonId = personId;
        this.printable = true;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
        if (!CommonFunctions.hasGuidValue(this.orderNotesPersonId)) {
            this.orderNotesPersonId = personId;
        }
    }
  orderNotesId: any;
  notes: string;
  printable: boolean;
  personName: string;
  updateUserId: any;
  updateDt: Date;
  insertUserId: any;
  insertDt: Date;
  orderId: any;
    orderNotesPersonId: any;
  //assignedPersonId: any;
}
